'use client'

import * as UI from '../footer.styled'
import React, {useEffect, useState} from 'react'
import {isMobile} from '@/src/shared/utils/functions'
import semver from 'semver'

export const Copyright: React.FC = () => {
  const [appVersion, setAppVersion] = useState('')

  useEffect(() => {
    if (isMobile()) {
      import('@runlab/mobile-utils/lib/updates/utils').then(({waitReadyUpdates, waitVersion}) => {
        waitReadyUpdates()
          .then(waitVersion)
          .then(async version => {
            const {CapacitorAppInfoProvider, CapacitorBundleManager} = await import(
              '@runlab/mobile-utils/lib/updates/updates'
            )
            const appInfoProvider = new CapacitorAppInfoProvider(version)
            const bundleManager = new CapacitorBundleManager(version)

            const appVersion = await appInfoProvider.getAppVersion()
            const bundleVersion = await bundleManager.getCurrentBundleVersion()

            if (semver.gte(appVersion, bundleVersion)) {
              setAppVersion(appVersion)
            } else {
              setAppVersion(bundleVersion)
            }
          })
      })
    }
  }, [])

  return (
    <>
      <UI.Copyright>
        {'\u00A9'} 2012-{new Date().getFullYear()} Runlab
      </UI.Copyright>
      {appVersion && <p>v. {appVersion}</p>}
    </>
  )
}
